import { PayloadAction, createAction, createSlice } from "@reduxjs/toolkit";
import { User, Achievement as AchievementType } from "@onmo/graphql/graphql";

interface IUser {
  user?: User | null;
  achievements?: AchievementType[] | null;
}

const initialState = {
  user: null,
  achievements: null,
} as IUser;

export const resetUserState = createAction("user/resetState");

export const userSlice = createSlice({
  name: "user",
  initialState: initialState,
  reducers: {
    updateUser: (state, action: PayloadAction<{ user: User }>) => {
      state.user = action.payload.user;
    },
    updateAchievements: (
      state,
      action: PayloadAction<{ achievements: AchievementType[] }>,
    ) => {
      state.achievements = action.payload.achievements;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetUserState, () => initialState);
  },
});

// Action creators are generated for each case reducer function
export const { updateUser, updateAchievements } = userSlice.actions;

export default userSlice.reducer;
